
<!-- Content Header (Page header) -->
<section class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1>Vehicles</h1>
        </div>
      </div>
    </div>
    <!-- /.container-fluid -->
  </section>
  <!-- Main content -->
  <section class="content">
    <!-- Default box -->
    <div class="container-fluid">
        <div class="row">
          <!-- <iframe #iframe ></iframe> -->
          <!-- left column -->
          <div class="col-md-12">
    
            <div class="card">
              <div class="card-header">
                <h3 class="card-title" *ngIf="isReadMode">Vehicle List</h3>
                <h3 class="card-title" *ngIf="isUpdateMode">Edit Vehicle</h3>
                <h3 class="card-title" *ngIf="isDeleteMode">Delete Vehicle</h3>
    
                <div class="card-tools">
                  <button type="button" class="btn btn-tool" data-widget="collapse" data-toggle="tooltip" title="Collapse">
                    <i class="fa fa-minus"></i>
                  </button>
                  <button type="button" class="btn btn-tool" data-widget="remove" data-toggle="tooltip" title="Remove">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
    
                <div class="container" *ngIf="isReadMode">
                  <div class="row">
                    <div class="col">
                      <label>Search by Vehicle No.</label> <input [(ngModel)]="seachText" class="form-control">
                      <!-- <label>Value is {{FSWRegistrationNo}}</label> -->
                    </div>
                    <!-- <div class="col">
                    <label>Select State:</label>
                    <ng-select [items]="states" bindLabel="stateName" autofocus bindValue="stateCode"
                      [(ngModel)]="selectedState">
                    </ng-select>
                  </div> -->
                    <div class="col">
                      <label>From Date</label> <input [(ngModel)]="fromDate" class="form-control" type="date">
                    </div>
                    <div class="col">
                      <label>End Date</label> <input [(ngModel)]="endDate" [min]="fromDate" class="form-control" type="date">
                    </div>
                  </div>
                  <br />
                  <div class="col"><input type="button" class="btn btn-primary"
                    value="Search" (click)="search()" /> &nbsp;&nbsp;&nbsp;
                    <input type="button" class="btn btn-primary"
                    value="Reset" (click)="reset()" /></div>
                  <div class="row">
    
                    <div class="col-md-12">
                      <p style="float:right"><input type="button" class="btn btn-link" (click)="back()" class="btn btn-link" value="Back"></p>
                    </div>
                  </div>
                  <br />

                  <!-- <div class="container">
                  
                    <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#myModal">
                      Open modal
                    </button>
                  
                    <div class="modal" id="myModal">

                      <div class="modal-dialog">
                        <div class="modal-content">
                        
                      
                          <div class="modal-header">
                            <h4 class="modal-title">Modal Heading</h4>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                          </div>
                          
                      
                        <div class="modal-body">

                          <iframe width="50" height="20" src="https://inroute.intangles.com/" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                        
                       
                        <div class="modal-footer">
                          <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                        </div>
                        
                      </div>
                    </div>
                  </div>                  
                </div> -->
                
                
                <div class="row">
                  <div class="col-md-6">
                    <label>State Name : {{state_name}}</label>
                  </div>
                  <!-- <div class="col-md-6" *ngIf="role!='IT-TEAM'">
                        <p style="float:right">
                          <a [routerLink]="['/add-vehicle']" class="btn btn-link">Add New Vehicle</a></p>
                         <a href="./add-vehicle" class="btn btn-link">Add New Vehicle</a></p> 
                 </div> -->
                  
                </div>
                <br />
  
                <div class="row">
                  <div class="table-responsive no-padding">
                    <table class="table table-striped table-hover table-bordered">
                      <thead>
                        <tr>
                          <th style="font-weight:bold; width: 5%;">S. No.</th>
                          <th style="font-weight:bold; width: 10%;">Vehicle No.</th>
                          <!-- <th style="font-weight:bold; width: 10%;">District</th> -->
                          <!-- <th style="font-weight:bold; width: 5%;">MFTL Stations</th> -->
                          <th style="font-weight:bold; width: 10%;">Chasis No</th>
                          <!-- <th style="font-weight:bold; width: 10%;">Email</th>
                          <th style="font-weight:bold; width: 10%;">Mobile</th> -->
                          <th style="font-weight:bold; width: 10%;">Added/Updated On</th>
                        </tr>
  
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="let userSample of userRecordData | paginate : {itemsPerPage: 10, currentPage : p}; let i=index">
                          <td>{{ itemsPerPage * (p - 1) + i + 1 }}</td>
                          <td>
                            <input type="button" class="btn btn-link"
                            (click)="trackVehicle(userSample.vehicleNo)" [value]="userSample.vehicleNo">
                          </td>
                
                          <td>{{userSample.chasisNo}}</td>
            
                          <td>{{userSample.createdOn | date: 'dd-MM-yyyy'}}</td>
                 
                <!-- <div class="container-window"> -->
                
                  <!-- <input type="button" class="btn btn-primary" data-toggle="modal" data-target="#myModal1"
                  (click)="trackVehicle(userSample.vehicleNo)" [value]="userSample.vehicleNo"> -->
                 
                
                  <!-- <div class="modal" id="myModal1">

                    <div class="modal-dialog">
                      <div class="modal-content">
                      
                     
                        <div class="modal-header">
                          <h4 class="modal-title">Modal Heading</h4>
                          <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        
                      
                        <div class="modal-body">
                         
                          
                        </div>
                        
                       
                        <div class="modal-footer">
                          <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                        </div>
                        
                      </div>
                    </div>
                  </div>      -->

                 <!-- </div>  -->

                        </tr>
                      </tbody>
                    </table>
                    <pagination-controls (pageChange)="p = $event" class="float-right"></pagination-controls>
                  </div>
                </div>
  
  
              </div>
              <!-- <h1 *ngIf="!isReadMode">Update Vehicle</h1> -->
              <div class="container" *ngIf="isUpdateMode">
                <div class="row">
                  <div class="col-mod-12">
  
  
                    <form [formGroup]="addVehicleForm" (ngSubmit)="onupdateUserSubmit()">
                      <!-- <h5 *ngIf="success">Your form is valid!</h5> -->
                      <div class="form-group">
                        <label>
                            State:
                            <select [(ngModel)]="selectedState" style="width:600px" formControlName="stateCode" class="form-control">
                                <option [ngValue]="null" selected disabled>Select State</option>
                                <option *ngFor="let state of StateRecord" [ngValue]="state.stateCode">
                                    {{state.stateName}}</option>
                            </select>
                            <div *ngIf="submitted && addVehicleForm.controls.stateCode.errors" class="error">
                                <div *ngIf="addVehicleForm.controls.stateCode.errors.required"
                                    style="color:red">State is required</div>
                            </div>
                        </label>
                    </div>
                    <div class="form-group"></div>
                    <div class="form-group">
                        <label style="font-weight:bold">
                            Vehicle No. :
                            <input type="text" style="width:600px" formControlName="vehicleNo" class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && f.vehicleNo.errors }">
                            <div *ngIf="submitted && f.vehicleNo.errors" class="invalid-feedback">
                                <div *ngIf="f.vehicleNo.errors.required">Vehicle No. is required</div>
                            </div>
                        </label>
                    </div>
                    <div class="form-group">
                        <label style="font-weight:bold">
                            Chasis No. :
                            <input type="text" style="width:600px" formControlName="chasisNo" class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && f.vehicleNo.errors }">
                            <div *ngIf="submitted && addVehicleForm.controls.chasisNo.errors"
                                class="invalid-feedback">
                                <div *ngIf="addVehicleForm.controls.chasisNo.errors.required" style="color:red">
                                    Chasis No. is required</div>
                            </div>
                        </label>
                    </div>
                    <div class="form-group">
                        <label style="font-weight:bold">
                            MFTL Station :
                            <input type="text" style="width:600px" formControlName="city" class="form-control">
  
                        </label>
                    </div>
                    <div class="form-group">
                        <label style="font-weight:bold">
                            Email Id. :
                            <input type="email" style="width:600px" formControlName="emailId" class="form-control">
                            <div *ngIf="submitted && addVehicleForm.controls.emailId.errors" class="error">
                                <div *ngIf="addVehicleForm.controls.emailId.errors.required" style="color:red">
                                    Email Id is required</div>
                            </div>
                        </label>
                    </div>
                    <div class="form-group">
                        <label style="font-weight:bold">
                            Mobile No. :
                            <input type="text" style="width:600px" formControlName="mobileNo" class="form-control">
                            <div *ngIf="submitted && addVehicleForm.controls.mobileNo.errors && addVehicleForm.controls.mobileNo.invalid"
                                class="error">
                                <div *ngIf="addVehicleForm.controls.mobileNo.errors.required" style="color:red">
                                    Mobile No. is required</div>
                                <div *ngIf="addVehicleForm.controls.mobileNo.errors.pattern">Please, Enter 10
                                    digit Mobile Number.</div>
                            </div>
                        </label>
                    </div>
  
  
  
  
                      <div class="form-group"><input type="submit" value="Submit" class="btn btn-primary"
                          [disabled]="!addVehicleForm.valid"></div>
                      <div *ngIf="success" class="alert alert-success alert-dismissible fade show" role="alert">
                        <strong>Success!</strong> Your data has been saved successfully.
                        <button (click)="closeAlert()" type="button" class="close" data-dismiss="alert"
                          aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </form>
                    <div class="box-header with-border">
                      <p style="float:right">
                        <!-- <a href="./list-vehicle/{{stateCode}}" class="btn btn-link">Back</a> -->
                        <a [routerLink]="['/list-vehicle/',stateCode]" class="btn btn-link">Back</a>
                      </p>
                    </div>
                  </div>
  
                </div>
              </div>
              <!-- Delete Vehicle</h1> -->
              <div class="container" *ngIf="isDeleteMode">
                <div class="row">
                  
                  <div class="col-md-1" style="font-weight:bold">
                    <label for="">User ID :</label>
                  </div>
                  <div class="col-md-4">
                    <label>{{userId}}</label>
                  </div>
  
                  <div class="col-md-1">
  
                  </div>
                  <div class="col-md-2" style="font-weight:bold">
                    <label for="">Vehicle No. :</label>
  
                  </div>
                  <div class="col-md-4">
                    <label>{{vehicleNo}}</label>
                  </div>
                  
  
                </div>
                <div class="row">
                 <div class="col-md-1" style="font-weight:bold">
                    <label for="">Email ID :</label>
                  </div>
                  <div class="col-md-4">
                    <label>{{emailId}}</label>
                  </div>
  
                  <div class="col-md-1">
  
                  </div>
                  <div class="col-md-2" style="font-weight:bold">
                    <label for="">Mobile No. :</label>
  
                  </div>
                  <div class="col-md-4">
                    <label>{{mobileNo}}</label>
                  </div>
                  
  
                </div>
                
                  <div class="row">
                    <div class="col-md-1" style="font-weight:bold;">
                      <label for="">Remark :</label>
                    </div>
                    <div class="col-md-4">
                      <textarea  [(ngModel)]="adminRemark" class="form-control"> </textarea>
                    </div>
                    <div class="col-md-2">
  
                    </div>
  
                  </div>
                  <br/>
                  <div class="row" style="text-align:center;">
                    <div class="col"><input type="button" class="btn btn-danger"  value="Delete" (click)="ondeleteUserSubmit()" />
                    </div>
                    <div class="col">
                      <!-- <a href="./list-vehicle/{{stateCode}}" class="btn btn-link">Back</a> -->
                      <a [routerLink]="['/list-vehicle/',stateCode]" class="btn btn-link">Back</a>
                    </div>
                    
                  </div>
                  <div *ngIf="success" class="alert alert-success alert-dismissible fade show" role="alert">
                    <strong>Success!</strong> Your data has been deleted successfully.
                    <button (click)="closeAlert()" type="button" class="close" data-dismiss="alert"
                      aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
  </ngx-spinner>